import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const localRole = localStorage.getItem("role");

  if (!token) {
    return <Navigate to="/adminportal" />;
  }

  try {
    const decoded = jwtDecode(token);
    const tokenRole = decoded.role;

    // Compare token role with localStorage role
    if (String(tokenRole) !== String(localRole)) {
      // Mismatch - remove token and role from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      return <Navigate to="/adminportal" />;
    }

    // Everything matches
    return children;
  } catch (error) {
    // Token is invalid or expired
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    return <Navigate to="/adminportal" />;
  }
};

export default ProtectedRoute;
